export type CountryCode = 'se' | 'dk' | 'no' | 'fi' | 'pl' | 'de';

export const countryCodes: CountryCode[] = ['se', 'dk', 'no', 'fi', 'pl', 'de'];


export const countryCodesUpperCase = countryCodes.map(c => c.toUpperCase());